/**
 * Sanitizes a file name for safe use in S3 keys and CDN URLs.
 * Removes characters that break URLs (#, ?, &, +, %, etc.),
 * strips spaces, and collapses consecutive underscores.
 */
export const sanitizeFileName = (name) => {
    if (!name) return name;
    const dotIndex = name.lastIndexOf('.');
    const baseName = dotIndex > 0 ? name.substring(0, dotIndex) : name;
    const extension = dotIndex > 0 ? name.substring(dotIndex) : '';

    const sanitized = baseName
        .replace(/[^a-zA-Z0-9._-]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');

    return (sanitized || 'file') + extension;
};
